import React from "react";
import styled from "styled-components";
import { Input } from "../../lib";
import { i18n } from "../../services";
import { device } from "../../helpers/style";

const Container = styled.div`
    margin: 0 auto 60px auto;
    width: 75%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media ${device.phone} {
        width: 100%;
        margin-bottom: 40px;
    }
`;

type Props = {
    filter: string;
    onChange: (k: string, filter: string) => void;
};
export default function SearchDocs({ filter, onChange }: Props) {
    return (
        <Container>
            <Input
                name="search_docs"
                fullWidth={true}
                textAlign="center"
                placeholder={i18n.get("doc.search")}
                value={filter}
                onChange={onChange}
            />
        </Container>
    );
}
